import React from 'react';
import {
  Dimmer,
  Box,
  Row,
  Container,
  Divider,
  RouterNavLink,
  ExternalLink,
} from '../core';
import { ConnectWallet } from '../ConnectWallet';
import { ToggleMenu } from './ToggleMenu';
import { useBreakpointIndex } from '@theme-ui/match-media';
import { Logo } from './Logo';
import { ModalContext } from '../../context/ModalContext';

export const Header = (): JSX.Element => {
  const mobile = useBreakpointIndex() === 0;
  const { modal } = React.useContext(ModalContext);
  return (
    <header>
      <Container variant="layout.header">
        <Row sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <Row mr={3} sx={{ alignItems: 'center' }}>
            <Logo />
            <Box mr={[0, 6]} />
            <Box>
              {!mobile && (
                <Row>
                  <RouterNavLink exact to="/">
                    Vaults
                  </RouterNavLink>
                  <Box mr={4} />
                  <ExternalLink
                    sx={{ variant: 'a.nav' }}
                    href="https://docs.scion.finance/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Docs
                  </ExternalLink>
                </Row>
              )}
            </Box>
          </Row>
          <Row sx={{ alignItems: 'center' }}>
            {!mobile && <Dimmer />}
            <Box sx={{ mr: 3 }} />
            {!mobile && <ConnectWallet />}
            {(modal || !!mobile) && <ToggleMenu />}
          </Row>
        </Row>
      </Container>
      <Divider mt={0} mb={0} />
    </header>
  );
};
